import type { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    selectImages: true;
  }
}

export const components: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        color: '#022b3a',
        backgroundColor: '#fafbfc',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
        color: '#022b3a',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        color: '#022b3a',
      },
      outlined: {
        borderColor: '#e7e7e7',
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: '90px',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 15,
        color: '#022b3a',
      },
      contained: {
        backgroundColor: '#ffd04b',
        borderRadius: 30,
        border: 0,
        padding: '8px 20px',
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
        '&:hover': {
          backgroundColor: '#ffd04b',
          boxShadow: 'none',
        },
      },
    },
    variants: [
      {
        props: { variant: 'selectImages' },
        style: {
          borderRadius: 0,
          border: '1px solid #f7f7f7',
          backgroundColor: '#04ceff',
          width: '100%',
          color: '#fff',
          fontWeight: 700,
          padding: '10px 0 10px 0',
        },
      },
    ],
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 3,
      },
      notchedOutline: {
        borderColor: '#e6e6e6',
        borderWidth: 2,
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: '#f2f3f5',
        },
        '&.Mui-selected:hover': {
          backgroundColor: '#f2f3f5',
        },
        '&:hover': {
          backgroundColor: '#f2f3f5',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 5,
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: 3,
        boxShadow: '0 1px 4px #cccccc',
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      h5: {
        fontSize: '25px',
        fontWeight: 700,
      },
      h6: {
        fontSize: '25px',
        fontWeight: 700,
      },
      subtitle2: {
        fontWeight: 700,
      },
    },
  },
};
